import { Box } from '@mui/material';
import { MultiSwitch } from 'components/ui';
import React, { ReactElement } from 'react';

export interface HideSchoolSwitchProps {
  isHidden: boolean;
  onChange: (selection: string) => void;
}

export const HideSchoolSwitch = ({
  isHidden,
  onChange,
}: HideSchoolSwitchProps): ReactElement => {
  return (
    <Box className="HideSchoolSwitch">
      <MultiSwitch
        variant="tempered"
        options={['Hidden', 'Active']}
        selection={isHidden ? 'Hidden' : 'Active'}
        onChange={onChange}
      />
    </Box>
  );
};
